export enum imgTypes {
  YES = 'YES',
  ERROR = 'ERROR',
}
